module.exports = __webpack_public_path__ + "img/ad_cn1.37d48722.png";